import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PatientReferencePanel = ({ patientData }) => {
  const [activeTab, setActiveTab] = useState('vitals');

  const tabs = [
    { id: 'vitals', label: 'Vitals', icon: 'Activity' },
    { id: 'medications', label: 'Medications', icon: 'Pill' },
    { id: 'allergies', label: 'Allergies', icon: 'AlertTriangle' },
    { id: 'labs', label: 'Labs', icon: 'FlaskConical' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between p-4 border-b border-border bg-muted/30">
        <h3 className="text-sm md:text-base font-semibold text-foreground">Patient Reference</h3>
        <button className="flex items-center justify-center w-8 h-8 rounded hover:bg-muted transition-smooth">
          <Icon name="Maximize2" size={16} />
        </button>
      </div>
      <div className="flex border-b border-border overflow-x-auto">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center gap-2 px-4 py-3 text-sm font-medium transition-smooth flex-shrink-0 ${
              activeTab === tab?.id
                ? 'text-primary border-b-2 border-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
          >
            <Icon name={tab?.icon} size={16} />
            <span className="hidden sm:inline">{tab?.label}</span>
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {activeTab === 'vitals' && (
          <>
            {patientData?.vitals?.map((vital, idx) => (
              <div key={idx} className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
                <div className="flex items-center gap-3">
                  <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded">
                    <Icon name={vital?.icon} size={16} color="var(--color-primary)" />
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground">{vital?.label}</p>
                    <p className="text-sm font-semibold text-foreground">{vital?.value}</p>
                  </div>
                </div>
                <span className={`text-xs px-2 py-1 rounded ${
                  vital?.status === 'normal' ? 'bg-success/10 text-success' :
                  vital?.status === 'warning'? 'bg-warning/10 text-warning' : 'bg-destructive/10 text-destructive'
                }`}>
                  {vital?.status}
                </span>
              </div>
            ))}
          </>
        )}

        {activeTab === 'medications' && (
          <>
            {patientData?.medications?.map((med, idx) => (
              <div key={idx} className="p-3 bg-muted/50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <p className="text-sm font-semibold text-foreground">{med?.name}</p>
                  <span className="text-xs px-2 py-1 bg-primary/10 text-primary rounded">{med?.status}</span>
                </div>
                <p className="text-xs text-muted-foreground mb-1">{med?.dosage}</p>
                <p className="text-xs text-muted-foreground">Prescribed: {med?.prescribedDate}</p>
              </div>
            ))}
          </>
        )}

        {activeTab === 'allergies' && (
          <>
            {patientData?.allergies?.map((allergy, idx) => (
              <div key={idx} className="flex items-start gap-3 p-3 bg-destructive/5 border border-destructive/20 rounded-lg">
                <Icon name="AlertTriangle" size={16} color="var(--color-destructive)" className="flex-shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground">{allergy?.allergen}</p>
                  <p className="text-xs text-muted-foreground mt-1">{allergy?.reaction}</p>
                  <p className="text-xs text-destructive mt-1">Severity: {allergy?.severity}</p>
                </div>
              </div>
            ))}
          </>
        )}

        {activeTab === 'labs' && (
          <>
            {patientData?.labs?.map((lab, idx) => (
              <div key={idx} className="p-3 bg-muted/50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <p className="text-sm font-semibold text-foreground">{lab?.test}</p>
                  <span className="text-xs text-muted-foreground whitespace-nowrap">{lab?.date}</span>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-xs text-muted-foreground">Result: <span className="text-foreground font-medium">{lab?.result}</span></p>
                  <span className={`text-xs px-2 py-1 rounded ${
                    lab?.flag === 'Normal' ? 'bg-success/10 text-success' :
                    lab?.flag === 'High'? 'bg-warning/10 text-warning' : 'bg-destructive/10 text-destructive'
                  }`}>
                    {lab?.flag}
                  </span>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default PatientReferencePanel;